import React from "react";
import EnhancedContentSection from "./../../components/common/enhanced-content-section";
import ButtonFx from "./../../components/common/button-fx";
import PageTagging from "components/common/page-tagging/page-tagging";
import "./careers.scss";

const Careers = () => {
const handleApplyNow = () => {
  const emailAddress = "Careers@mrtraffic.com.au";
  const subject = encodeURIComponent("Application for Employment");

  window.open(
    `mailto:${emailAddress}?subject=${subject}`,
    "_blank",
    "noopener,noreferrer"
  );
};

  return (
    <>
<PageTagging
  title="Careers | Join the Mr Traffic Australia Team"
  description="Explore career opportunities with Mr Traffic Australia and submit an expression of interest to join our growing team."
/>

<section className="careers-hero">
  <div className="careers-hero-inner">
    <div className="careers-hero-content">
      <span className="careers-hero-eyebrow">Careers</span>

      <h1>
        Want to join the{" "}
        <span>Mr Traffic Australia team?</span>
      </h1>

      <p>
        We&apos;re always interested in hearing from motivated, reliable and
        safety-focused people who would like to become part of our growing
        national team.
      </p>

      <ButtonFx
        className="mt-aqua-mini-button careers-hero-button"
        onClick={handleApplyNow}
      >
        <i className="fas fa-envelope mr-2"></i>
        Apply Now
      </ButtonFx>
    </div>

    <div className="careers-hero-image">
      <img
        src="/images/mr-traffic-hero-2.jpg"
        alt="Careers at Mr Traffic Australia"
      />
    </div>
  </div>
</section>

      <EnhancedContentSection isBlocking={false} showPageTitle={false}>

        <div className="careers-intro">
          <div className="careers-intro-content">
            <span className="careers-eyebrow">Join Our Team</span>

            <h2>Build your career with a growing national team</h2>

            <p className="careers-lead">
              Mr Traffic Australia is always interested in hearing from
              motivated, reliable and safety-focused people who would like to
              become part of our growing team.
            </p>

            <p>
              We support projects of all sizes by providing dependable traffic
              equipment hire and responsive service across Australia. Our people
              play an important role in keeping projects moving safely and
              efficiently.
            </p>

            <p>
              Whether you have experience in traffic management, equipment
              operations, logistics, customer service or administration, we
              welcome expressions of interest from people who share our
              commitment to safety, quality and teamwork.
            </p>
          </div>

          <aside
            className="careers-highlights"
            aria-label="Working with Mr Traffic Australia"
          >
            <h3>Why Mr Traffic Australia?</h3>

            <div className="careers-highlight-item">
              <div className="careers-highlight-icon">
                <i className="fas fa-shield-check"></i>
              </div>

              <div>
                <h4>Safety Focused</h4>
                <p>
                  Join a team committed to safe, dependable and professional
                  service.
                </p>
              </div>
            </div>

            <div className="careers-highlight-item">
              <div className="careers-highlight-icon">
                <i className="fas fa-users"></i>
              </div>

              <div>
                <h4>Team Environment</h4>
                <p>
                  Work alongside practical, experienced and supportive team
                  members.
                </p>
              </div>
            </div>

            <div className="careers-highlight-item">
              <div className="careers-highlight-icon">
                <i className="fas fa-road"></i>
              </div>

              <div>
                <h4>Growing Business</h4>
                <p>
                  Become part of a business supporting infrastructure and
                  projects across Australia.
                </p>
              </div>
            </div>
          </aside>
        </div>

        <section className="careers-opportunities">
          <div className="careers-opportunities-heading">
            <span className="careers-eyebrow">Expressions of Interest</span>

            <h2>We are always looking for great people</h2>

            <p>
              Even when a specific position is not currently advertised, you
              are welcome to send us your details. Tell us about your experience,
              qualifications and the type of work you are interested in.
            </p>
          </div>

          <div className="careers-role-grid">
            <article className="careers-role-card">
              <i className="fas fa-truck"></i>
              <h3>Operations</h3>
              <p>
                Equipment delivery, collection, setup, maintenance and
                operational support.
              </p>
            </article>

            <article className="careers-role-card">
              <i className="fas fa-tools"></i>
              <h3>Equipment Support</h3>
              <p>
                Supporting the preparation, presentation and reliability of our
                traffic equipment fleet.
              </p>
            </article>

            <article className="careers-role-card">
              <i className="fas fa-headset"></i>
              <h3>Office and Customer Support</h3>
              <p>
                Customer service, administration, scheduling and general
                business support roles.
              </p>
            </article>
          </div>
        </section>
      </EnhancedContentSection>

      <section className="careers-apply-section">
        <div className="careers-apply-inner">
          <div className="careers-apply-content">
            <span className="careers-apply-eyebrow">Ready to get started?</span>

            <h2>
              Take the next step and <span>join our team</span>
            </h2>

            <p>
              Email your résumé and a brief introduction outlining your
              experience and the type of position you are seeking.
            </p>
          </div>

          <ButtonFx
            className="mt-aqua-mini-button careers-apply-button"
            onClick={handleApplyNow}
          >
            <i className="fas fa-envelope mr-2"></i>
            Apply Now
          </ButtonFx>
        </div>
      </section>
    </>
  );
};

export default Careers;